export default "__VITE_ASSET__Dn6AGzhT__"